export const SDB_TEMPLATE_TOUR_ID = "sdb-template-tour";
